<template>
  <div>
    <b-modal id="loginPopup" ref="loginPopup" class="fade login-dialog" centered hide-footer>
      <template slot="modal-header-close">
        <button type="button" class="btn btn-xs btn-icon btn-soft-secondary" data-dismiss="modal" aria-label="Close">
          <img :src="require(`@/assets/svg/icons/icon-68.svg`)">
        </button>
      </template>
      <div class="w-md-90 mx-auto mb-6">
        <div class="text-center">
          <h3>{{ $t('CC05-1-02a-01') }}</h3>
          <p>{{ $t('CC05-1-02a-02', { site_name: site_info[$i18n.locale.toLowerCase()].name }) }}</p>
          <img class="mt-3" :src="require(`@/assets/svg/illustrations/api-community.svg`)">
          <a id="ga-CC05-1-02" :href="afterLoginLink">
            <span class="d-block mt-5 btn btn-primary">{{ $t('CC05-1-02b') }}</span>
          </a>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'LoginPopup',
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    afterLogin: {
      type: String,
      default: 'apiEndpoint'
    }
  },
  data() {
    return {
      MARKETPLACE_URL: ''
    }
  },
  computed: {
    afterLoginLink() {
      if (this.item) {
        var provider_name = (this.item.display_name.toLowerCase().replace(/[^A-Za-z0-9]/g, '-').concat(`-${this.item.provider_short_id}`)).replace(/\-+/g, '-')
        var api_name = (this.item.api_name.toLowerCase().replace(/[^A-Za-z0-9]/g, '-').concat(`-${this.item.api_short_id}`)).replace(/\-+/g, '-')
        var link = ''
        switch (this.afterLogin) {
          case 'apiEndpoint':
            link += `/${provider_name}/api/${api_name}/endpoint`
            break
          case 'apiReadme':
            link += `/${provider_name}/api/${api_name}/readme`
            break
          case 'apiEndpointBranded':
            link += `/${provider_name}/api/${api_name}/endpoint`
            break
          case 'apiReadmeBranded':
            link += `/${provider_name}/api/${api_name}/readme`
            break
          default:
            link += `/${provider_name}/api/${api_name}/readme`
            break
        }
        return this.$keycloak.createLoginUrl({ redirectUri: `${window.location.origin}${link}` })
      } else return this.$keycloak.createLoginUrl({ redirectUri: `${window.location.origin}/${this.provider_path}` })
    },
    ...mapGetters([
      'site_info', 'provider_path'
    ])
  },
  methods: {
    showFormDialog() {
      this.$refs['loginPopup'].show()
    }
  }
}
</script>

<style lang="scss" scoped>
.login-dialog {
  padding: 10px !important;
  z-index: 1080;
}
.modal-header {
  border-bottom: 0;
}
</style>
